import React from 'react';
import PropTypes from 'prop-types';

// Component
import Link from '../../Link/Link';

const PinterestButton = ({ postLink, title }) => (
  <Link
    className="social-button-link"
    target="_blank"
    rel="noopener noreferrer"
    href={`http://pinterest.com/pin/create/button/?url=${postLink}&media=&description=${title}`}
    title={title}
  >
    <div className="social-button-icon flex-center">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM12.9258 14.6725C12.1815 14.6725 11.4816 14.2702 11.2421 13.8134C11.2421 13.8134 10.8417 15.4014 10.7573 15.708C10.4588 16.791 9.58081 17.8748 9.51288 17.9636C9.46527 18.0254 9.36017 18.006 9.34906 17.9242C9.33014 17.7861 9.10638 16.4195 9.36975 15.3048C9.50201 14.7451 10.2563 11.549 10.2563 11.549C10.2563 11.549 10.0365 11.1088 10.0365 10.4583C10.0365 9.43677 10.6286 8.67413 11.3657 8.67413C11.9925 8.67413 12.2954 9.14477 12.2954 9.70892C12.2954 10.3392 11.894 11.2816 11.6869 12.1548C11.5139 12.8862 12.0536 13.4825 12.7747 13.4825C14.0804 13.4825 14.96 11.8052 14.96 9.81775C14.96 8.30725 13.943 7.17627 12.092 7.17627C10.0017 7.17627 8.69843 8.7356 8.69843 10.4775C8.69843 11.0779 8.8758 11.5018 9.15339 11.8292C9.28077 11.9799 9.29865 12.0405 9.25251 12.2134C9.21888 12.3404 9.14356 12.6455 9.1117 12.7665C9.06592 12.9413 8.92451 13.0036 8.76667 12.9391C7.80402 12.546 7.35517 11.4913 7.35517 10.3059C7.35516 8.3479 9.00635 6 12.2812 6C14.9131 6 16.6448 7.90405 16.6448 9.94867C16.6448 12.6525 15.1416 14.6725 12.9258 14.6725Z"
          fill="#E70022"
        />
      </svg>
    </div>
  </Link>
);

PinterestButton.propTypes = {
  postLink: '',
};

PinterestButton.propTypes = {
  title: PropTypes.string.isRequired,
  postLink: PropTypes.string.isRequired,
};

export default PinterestButton;
